// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/webhooks/v1/webhooks.proto" (package "c1.api.webhooks.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Duration } from "../../../../google/protobuf/duration";
import { Struct } from "../../../../google/protobuf/struct";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookInstance
 */
export interface WebhookInstance {
    /**
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 5;
     */
    expiresAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_attempted_at = 6;
     */
    lastAttemptedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 7;
     */
    completedAt?: Timestamp;
    /**
     * @generated from protobuf field: int32 attempts = 8;
     */
    attempts: number;
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.WebhookInstance.WebhookState state = 9;
     */
    state: WebhookInstance_WebhookState;
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.WebhookSource source = 10;
     */
    source?: WebhookSource;
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.WebhookSpec spec = 11;
     */
    spec?: WebhookSpec;
}
/**
 * @generated from protobuf enum c1.api.webhooks.v1.WebhookInstance.WebhookState
 */
export enum WebhookInstance_WebhookState {
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_RUNNING = 2;
     */
    RUNNING = 2,
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_ERROR = 3;
     */
    ERROR = 3,
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_WAITING_CALLBACK = 4;
     */
    WAITING_CALLBACK = 4,
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_PROCESS_RESPONSE = 5;
     */
    PROCESS_RESPONSE = 5,
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_SUCCESS = 6;
     */
    SUCCESS = 6,
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_FATAL_ERROR = 7;
     */
    FATAL_ERROR = 7
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.Webhook
 */
export interface Webhook {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string display_name = 5;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string url = 6;
     */
    url: string;
    /**
     * @generated from protobuf field: string description = 7;
     */
    description: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookRef
 */
export interface WebhookRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookInstanceRef
 */
export interface WebhookInstanceRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string webhook_id = 2;
     */
    webhookId: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookSource
 */
export interface WebhookSource {
    /**
     * @generated from protobuf oneof: source
     */
    source: {
        oneofKind: "test";
        /**
         * @generated from protobuf field: c1.api.webhooks.v1.WebhookSource.WebhookSourceTest test = 100;
         */
        test: WebhookSource_WebhookSourceTest;
    } | {
        oneofKind: "policyPostAction";
        /**
         * @generated from protobuf field: c1.api.webhooks.v1.WebhookSource.WebhookSourcePolicyPostAction policy_post_action = 101;
         */
        policyPostAction: WebhookSource_WebhookSourcePolicyPostAction;
    } | {
        oneofKind: "approvalStep";
        /**
         * @generated from protobuf field: c1.api.webhooks.v1.WebhookSource.WebhookSourceApprovalStep approval_step = 102;
         */
        approvalStep: WebhookSource_WebhookSourceApprovalStep;
    } | {
        oneofKind: "provisionStep";
        /**
         * @generated from protobuf field: c1.api.webhooks.v1.WebhookSource.WebhookSourceProvisionStep provision_step = 103;
         */
        provisionStep: WebhookSource_WebhookSourceProvisionStep;
    } | {
        oneofKind: "workflowStep";
        /**
         * @generated from protobuf field: c1.api.webhooks.v1.WebhookSource.WebhookSourceWorkflowStep workflow_step = 104;
         */
        workflowStep: WebhookSource_WebhookSourceWorkflowStep;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceTest
 */
export interface WebhookSource_WebhookSourceTest {
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourcePolicyPostAction
 */
export interface WebhookSource_WebhookSourcePolicyPostAction {
    /**
     * @generated from protobuf field: string ticket_id = 1;
     */
    ticketId: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceApprovalStep
 */
export interface WebhookSource_WebhookSourceApprovalStep {
    /**
     * @generated from protobuf field: string ticket_id = 1;
     */
    ticketId: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceProvisionStep
 */
export interface WebhookSource_WebhookSourceProvisionStep {
    /**
     * @generated from protobuf field: string ticket_id = 1;
     */
    ticketId: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceWorkflowStep
 */
export interface WebhookSource_WebhookSourceWorkflowStep {
    /**
     * @generated from protobuf field: int64 workflow_execution_id = 1;
     */
    workflowExecutionId: number;
    /**
     * @generated from protobuf field: string workflow_step_id = 2;
     */
    workflowStepId: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookSpec
 */
export interface WebhookSpec {
    /**
     * @generated from protobuf field: string destination = 1;
     */
    destination: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookAttempt
 */
export interface WebhookAttempt {
    /**
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2;
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * @generated from protobuf field: int32 attempt = 4;
     */
    attempt: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: bytes request = 6;
     */
    request: Uint8Array;
    /**
     * @generated from protobuf field: google.protobuf.Struct request_headers = 7;
     */
    requestHeaders?: Struct;
    /**
     * @generated from protobuf field: bytes response = 8;
     */
    response: Uint8Array;
    /**
     * @generated from protobuf field: int32 response_status_code = 9;
     */
    responseStatusCode: number;
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.WebhookAttempt.WebhookResponseTiming response_timing = 10;
     */
    responseTiming?: WebhookAttempt_WebhookResponseTiming;
    /**
     * @generated from protobuf field: string msg = 11;
     */
    msg: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookAttempt.WebhookResponseTiming
 */
export interface WebhookAttempt_WebhookResponseTiming {
    /**
     * @generated from protobuf field: google.protobuf.Duration total = 1;
     */
    total?: Duration;
    /**
     * @generated from protobuf field: google.protobuf.Duration dns_lookup = 2;
     */
    dnsLookup?: Duration;
    /**
     * @generated from protobuf field: google.protobuf.Duration tcp_connection = 3;
     */
    tcpConnection?: Duration;
    /**
     * @generated from protobuf field: google.protobuf.Duration tls_handshake = 4;
     */
    tlsHandshake?: Duration;
    /**
     * @generated from protobuf field: google.protobuf.Duration server_processing = 5;
     */
    serverProcessing?: Duration;
    /**
     * @generated from protobuf field: google.protobuf.Duration content_transfer = 6;
     */
    contentTransfer?: Duration;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceTestRequest
 */
export interface WebhooksServiceTestRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceTestResponse
 */
export interface WebhooksServiceTestResponse {
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.WebhookInstance webhook = 1;
     */
    webhook?: WebhookInstance;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceCreateRequest
 */
export interface WebhooksServiceCreateRequest {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string url = 2;
     */
    url: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceCreateResponse
 */
export interface WebhooksServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.Webhook webhook = 1;
     */
    webhook?: Webhook;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceAttemptsRequest
 */
export interface WebhooksServiceAttemptsRequest {
    /**
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2;
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceAttemptsResponse
 */
export interface WebhooksServiceAttemptsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.webhooks.v1.WebhookAttempt list = 1;
     */
    list: WebhookAttempt[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceGetRequest
 */
export interface WebhooksServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceDeleteRequest
 */
export interface WebhooksServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * Empty response body. Status code indicates success.
 *
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceDeleteResponse
 */
export interface WebhooksServiceDeleteResponse {
}
/**
 * The WebhooksServiceUpdateRequest message contains the webhook object to update and a field mask to indicate which fields to update. It uses URL value for input.
 *
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceUpdateRequest
 */
export interface WebhooksServiceUpdateRequest {
    /**
     * The policy object with the changes to update.
     *
     * @generated from protobuf field: c1.api.webhooks.v1.Webhook webhook = 1;
     */
    webhook?: Webhook;
    /**
     * The update mask is a comma-sepparated string of fields to update. This may be something like "webhook_url".
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceUpdateResponse
 */
export interface WebhooksServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.Webhook webhook = 1;
     */
    webhook?: Webhook;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceGetResponse
 */
export interface WebhooksServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.Webhook webhook = 1;
     */
    webhook?: Webhook;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceListRequest
 */
export interface WebhooksServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceListResponse
 */
export interface WebhooksServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.webhooks.v1.Webhook list = 1;
     */
    list: Webhook[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksSearchRequest
 */
export interface WebhooksSearchRequest {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.webhooks.v1.WebhookRef refs = 5;
     */
    refs: WebhookRef[];
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksSearchResponse
 */
export interface WebhooksSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.webhooks.v1.Webhook list = 1;
     */
    list: Webhook[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookInstanceServiceListRequest
 */
export interface WebhookInstanceServiceListRequest {
    /**
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookInstanceServiceListResponse
 */
export interface WebhookInstanceServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.webhooks.v1.WebhookInstance list = 1;
     */
    list: WebhookInstance[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookPayload
 */
export interface WebhookPayload {
    /**
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2;
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 6;
     */
    expiresAt?: Timestamp;
    /**
     * zstd compressed payload body, a Protobuf Any message which we unmarshal
     * to create a WebhookAttempt with the per-Attempt body.
     *
     * @generated from protobuf field: string payload = 7;
     */
    payload: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookInstancePayloadGetRequest
 */
export interface WebhookInstancePayloadGetRequest {
    /**
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2;
     */
    webhookInstanceId: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookInstancePayloadGetResponse
 */
export interface WebhookInstancePayloadGetResponse {
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.WebhookPayload payload = 1;
     */
    payload?: WebhookPayload;
}
// @generated message type with reflection information, may provide speed optimized methods
class WebhookInstance$Type extends MessageType<WebhookInstance> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookInstance", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "expires_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "last_attempted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "completed_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "attempts", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "state", kind: "enum", T: () => ["c1.api.webhooks.v1.WebhookInstance.WebhookState", WebhookInstance_WebhookState, "WEBHOOK_STATE_"] },
            { no: 10, name: "source", kind: "message", T: () => WebhookSource },
            { no: 11, name: "spec", kind: "message", T: () => WebhookSpec }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookInstance
 */
export const WebhookInstance = new WebhookInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Webhook$Type extends MessageType<Webhook> {
    constructor() {
        super("c1.api.webhooks.v1.Webhook", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Webhook" } }] }, "policy.v1.msg": { enabled: true, name: "webhook", keyFields: ["id"] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.Webhook
 */
export const Webhook = new Webhook$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookRef$Type extends MessageType<WebhookRef> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookRef
 */
export const WebhookRef = new WebhookRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookInstanceRef$Type extends MessageType<WebhookInstanceRef> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookInstanceRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookInstanceRef
 */
export const WebhookInstanceRef = new WebhookInstanceRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookSource$Type extends MessageType<WebhookSource> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookSource", [
            { no: 100, name: "test", kind: "message", oneof: "source", T: () => WebhookSource_WebhookSourceTest },
            { no: 101, name: "policy_post_action", kind: "message", oneof: "source", T: () => WebhookSource_WebhookSourcePolicyPostAction },
            { no: 102, name: "approval_step", kind: "message", oneof: "source", T: () => WebhookSource_WebhookSourceApprovalStep },
            { no: 103, name: "provision_step", kind: "message", oneof: "source", T: () => WebhookSource_WebhookSourceProvisionStep },
            { no: 104, name: "workflow_step", kind: "message", oneof: "source", T: () => WebhookSource_WebhookSourceWorkflowStep }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookSource
 */
export const WebhookSource = new WebhookSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookSource_WebhookSourceTest$Type extends MessageType<WebhookSource_WebhookSourceTest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookSource.WebhookSourceTest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceTest
 */
export const WebhookSource_WebhookSourceTest = new WebhookSource_WebhookSourceTest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookSource_WebhookSourcePolicyPostAction$Type extends MessageType<WebhookSource_WebhookSourcePolicyPostAction> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookSource.WebhookSourcePolicyPostAction", [
            { no: 1, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourcePolicyPostAction
 */
export const WebhookSource_WebhookSourcePolicyPostAction = new WebhookSource_WebhookSourcePolicyPostAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookSource_WebhookSourceApprovalStep$Type extends MessageType<WebhookSource_WebhookSourceApprovalStep> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookSource.WebhookSourceApprovalStep", [
            { no: 1, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceApprovalStep
 */
export const WebhookSource_WebhookSourceApprovalStep = new WebhookSource_WebhookSourceApprovalStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookSource_WebhookSourceProvisionStep$Type extends MessageType<WebhookSource_WebhookSourceProvisionStep> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookSource.WebhookSourceProvisionStep", [
            { no: 1, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceProvisionStep
 */
export const WebhookSource_WebhookSourceProvisionStep = new WebhookSource_WebhookSourceProvisionStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookSource_WebhookSourceWorkflowStep$Type extends MessageType<WebhookSource_WebhookSourceWorkflowStep> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookSource.WebhookSourceWorkflowStep", [
            { no: 1, name: "workflow_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "workflow_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceWorkflowStep
 */
export const WebhookSource_WebhookSourceWorkflowStep = new WebhookSource_WebhookSourceWorkflowStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookSpec$Type extends MessageType<WebhookSpec> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookSpec", [
            { no: 1, name: "destination", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookSpec
 */
export const WebhookSpec = new WebhookSpec$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookAttempt$Type extends MessageType<WebhookAttempt> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookAttempt", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "attempt", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "request", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 7, name: "request_headers", kind: "message", T: () => Struct },
            { no: 8, name: "response", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 9, name: "response_status_code", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "response_timing", kind: "message", T: () => WebhookAttempt_WebhookResponseTiming },
            { no: 11, name: "msg", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookAttempt
 */
export const WebhookAttempt = new WebhookAttempt$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookAttempt_WebhookResponseTiming$Type extends MessageType<WebhookAttempt_WebhookResponseTiming> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookAttempt.WebhookResponseTiming", [
            { no: 1, name: "total", kind: "message", T: () => Duration },
            { no: 2, name: "dns_lookup", kind: "message", T: () => Duration },
            { no: 3, name: "tcp_connection", kind: "message", T: () => Duration },
            { no: 4, name: "tls_handshake", kind: "message", T: () => Duration },
            { no: 5, name: "server_processing", kind: "message", T: () => Duration },
            { no: 6, name: "content_transfer", kind: "message", T: () => Duration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookAttempt.WebhookResponseTiming
 */
export const WebhookAttempt_WebhookResponseTiming = new WebhookAttempt_WebhookResponseTiming$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceTestRequest$Type extends MessageType<WebhooksServiceTestRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceTestRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceTestRequest
 */
export const WebhooksServiceTestRequest = new WebhooksServiceTestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceTestResponse$Type extends MessageType<WebhooksServiceTestResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceTestResponse", [
            { no: 1, name: "webhook", kind: "message", T: () => WebhookInstance }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceTestResponse
 */
export const WebhooksServiceTestResponse = new WebhooksServiceTestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceCreateRequest$Type extends MessageType<WebhooksServiceCreateRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "3", maxLen: "100" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "3", maxLen: "2048" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "0", maxLen: "200" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceCreateRequest
 */
export const WebhooksServiceCreateRequest = new WebhooksServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceCreateResponse$Type extends MessageType<WebhooksServiceCreateResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceCreateResponse", [
            { no: 1, name: "webhook", kind: "message", T: () => Webhook }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceCreateResponse
 */
export const WebhooksServiceCreateResponse = new WebhooksServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceAttemptsRequest$Type extends MessageType<WebhooksServiceAttemptsRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceAttemptsRequest", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceAttemptsRequest
 */
export const WebhooksServiceAttemptsRequest = new WebhooksServiceAttemptsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceAttemptsResponse$Type extends MessageType<WebhooksServiceAttemptsResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceAttemptsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WebhookAttempt },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceAttemptsResponse
 */
export const WebhooksServiceAttemptsResponse = new WebhooksServiceAttemptsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceGetRequest$Type extends MessageType<WebhooksServiceGetRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceGetRequest
 */
export const WebhooksServiceGetRequest = new WebhooksServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceDeleteRequest$Type extends MessageType<WebhooksServiceDeleteRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceDeleteRequest
 */
export const WebhooksServiceDeleteRequest = new WebhooksServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceDeleteResponse$Type extends MessageType<WebhooksServiceDeleteResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceDeleteResponse
 */
export const WebhooksServiceDeleteResponse = new WebhooksServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceUpdateRequest$Type extends MessageType<WebhooksServiceUpdateRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceUpdateRequest", [
            { no: 1, name: "webhook", kind: "message", T: () => Webhook },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceUpdateRequest
 */
export const WebhooksServiceUpdateRequest = new WebhooksServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceUpdateResponse$Type extends MessageType<WebhooksServiceUpdateResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceUpdateResponse", [
            { no: 1, name: "webhook", kind: "message", T: () => Webhook }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceUpdateResponse
 */
export const WebhooksServiceUpdateResponse = new WebhooksServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceGetResponse$Type extends MessageType<WebhooksServiceGetResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceGetResponse", [
            { no: 1, name: "webhook", kind: "message", T: () => Webhook }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceGetResponse
 */
export const WebhooksServiceGetResponse = new WebhooksServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceListRequest$Type extends MessageType<WebhooksServiceListRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceListRequest
 */
export const WebhooksServiceListRequest = new WebhooksServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceListResponse$Type extends MessageType<WebhooksServiceListResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Webhook },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceListResponse
 */
export const WebhooksServiceListResponse = new WebhooksServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksSearchRequest$Type extends MessageType<WebhooksSearchRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WebhookRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksSearchRequest
 */
export const WebhooksSearchRequest = new WebhooksSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksSearchResponse$Type extends MessageType<WebhooksSearchResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Webhook },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksSearchResponse
 */
export const WebhooksSearchResponse = new WebhooksSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookInstanceServiceListRequest$Type extends MessageType<WebhookInstanceServiceListRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookInstanceServiceListRequest", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookInstanceServiceListRequest
 */
export const WebhookInstanceServiceListRequest = new WebhookInstanceServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookInstanceServiceListResponse$Type extends MessageType<WebhookInstanceServiceListResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookInstanceServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WebhookInstance },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookInstanceServiceListResponse
 */
export const WebhookInstanceServiceListResponse = new WebhookInstanceServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookPayload$Type extends MessageType<WebhookPayload> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookPayload", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "payload", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookPayload
 */
export const WebhookPayload = new WebhookPayload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookInstancePayloadGetRequest$Type extends MessageType<WebhookInstancePayloadGetRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookInstancePayloadGetRequest", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookInstancePayloadGetRequest
 */
export const WebhookInstancePayloadGetRequest = new WebhookInstancePayloadGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookInstancePayloadGetResponse$Type extends MessageType<WebhookInstancePayloadGetResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookInstancePayloadGetResponse", [
            { no: 1, name: "payload", kind: "message", T: () => WebhookPayload }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookInstancePayloadGetResponse
 */
export const WebhookInstancePayloadGetResponse = new WebhookInstancePayloadGetResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.webhooks.v1.WebhooksService
 */
export const WebhooksService = new ServiceType("c1.api.webhooks.v1.WebhooksService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/webhooks/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Webhook", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Webhook" }] } }, I: WebhooksServiceGetRequest, O: WebhooksServiceGetResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/webhooks/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Webhook" }], group: "Webhook" }] } }, I: WebhooksServiceDeleteRequest, O: WebhooksServiceDeleteResponse },
    { name: "Test", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/webhooks/{id}/test", group: "Webhook" }] } }, I: WebhooksServiceTestRequest, O: WebhooksServiceTestResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/webhooks", query: { page_size: "page_size", page_token: "page_token" }, group: "Webhook" }] } }, I: WebhooksServiceListRequest, O: WebhooksServiceListResponse },
    { name: "Attempts", options: { "authz.method": { role: "VIEWER" } }, I: WebhooksServiceAttemptsRequest, O: WebhooksServiceAttemptsResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/webhooks", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Webhook" }], group: "Webhook" }] } }, I: WebhooksServiceCreateRequest, O: WebhooksServiceCreateResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/webhooks/{webhook.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Webhook" }], group: "Webhook" }] } }, I: WebhooksServiceUpdateRequest, O: WebhooksServiceUpdateResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.webhooks.v1.WebhooksSearch
 */
export const WebhooksSearch = new ServiceType("c1.api.webhooks.v1.WebhooksSearch", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/webhooks", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Webhook", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }, { type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Webhooks", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Webhook", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", in: "TERRAFORM_ENTITY_PAGINATION_INPUT_IN_REQUEST_BODY", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: WebhooksSearchRequest, O: WebhooksSearchResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.webhooks.v1.WebhookInstanceService
 */
export const WebhookInstanceService = new ServiceType("c1.api.webhooks.v1.WebhookInstanceService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: WebhookInstanceServiceListRequest, O: WebhookInstanceServiceListResponse },
    { name: "GetPayload", options: { "authz.method": { role: "VIEWER" } }, I: WebhookInstancePayloadGetRequest, O: WebhookInstancePayloadGetResponse }
]);
